import * as types from '../actions/types'
import emailReducer from './email'

export const initState = {
  visible: false,
  email: undefined,
  instructionsSent: false,
  indicatorStatus: false,
  message: null,
  success: true,
}

const forgotPassword = (state = initState, action) => {
  switch (action.type) {
    case types.SET_USER_DEFAULT_EMAIL:
      return {
        ...state,
        email: emailReducer(state.email, action),
      }
    case types.SHOW_CUSTOMER_FORGOT_PASSWORD_MODAL:
      return {
        ...state,
        visible: true,
      }
    case types.CLOSE_CUSTOMER_FORGOT_PASSWORD_MODAL:
      return {
        ...initState,
        email: emailReducer(state.email, action),
      }
    case types.UPDATE_CUSTOMER_FORGOT_PASSWORD_EMAIL_FIELD:
      return {
        ...state,
        email: emailReducer(state.email, action),
      }
    case types.SHOW_INSTRUCTIONS_SENT_MESSAGE: {
      return {
        ...initState,
        email: emailReducer(state.email, action),
        instructionsSent: true,
        indicatorStatus: action.success,
        success: action.success,
        message: action.message,
      }
    }
    case types.RESET_FORGETPWD_FEILDS: {
      return {
        ...initState,
        email: emailReducer('', action),
      }
    }
    default:
      return {
        ...state,
        email: emailReducer(state.email, action),
      }
  }
}

export default forgotPassword
